import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AuthLoginService } from '../../services/auth-login.service';
import { CustomValidatorService } from 'src/app/shared/services/custom-validator.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { UserModuleConsts } from '../../constants';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { SharedConsts } from 'src/app/shared/constants';

@Component({
    selector: 'forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordForm: FormGroup;
  submitted = false;
  errMessage: any;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private titleService: Title,
    private authLoginService: AuthLoginService,
    private customValidator: CustomValidatorService,
    private statePersistService: StatePersistService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, this.customValidator.emailValidator]]
    });
    this.forgotPasswordForm.get('email').valueChanges
      .subscribe(email => {
        if (email) {
          this.errMessage = '';
        }
      });
    this.titleService.setTitle(UserModuleConsts.FORGOT_PASSWORD_PAGE_TITLE);
  }

  forgotPassword() {
    this.submitted = true;
    if (this.forgotPasswordForm.invalid) {
      return;
    }
    this.googleAnalyticsService.eventEmitter(SharedConsts.FORGOT_PASSWORD_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.FORGOT_PASSWORD_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    const email = this.forgotPasswordForm.controls.email.value;
    this.statePersistService.setLocalStorage('forgot_email', email)
    this.authLoginService.forgetPassword(this.forgotPasswordForm.value)
      .subscribe(
        data => {
          if (data.status === 111){
            this.errMessage = data.message.email[0];
          }
          else if (data.status == 401){
            alert(data.message)
          }
          else{
            this.router.navigate(['users/thank-you']);
          }
          
        },
        error => {
         
        }
      );
  }

}
